import { observer } from "mobx-react-lite";
import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { Container, Table, Label,  Button, Confirm, Menu, Icon, Image, Message, Popup, Dropdown } from "semantic-ui-react";
import EmployeeStore from "../../../app/stores/employeeStore";

const EmployeeList: React.FC = () => {
  const [employeeEmail, setEmployeeEmail] = useState("");
  const employeeStore = useContext(EmployeeStore);
  const {
    employeesByName: employeesByName,
    deleteEmployee: deleteEmployee,
    employeeRegistry,
    selectEmployeeTitle,
    submitting,
    target,
  } = employeeStore;

  const departmentList  = Array.from(employeeRegistry.values()).map((emp) => {
    return emp["department"];
  });
  const departments = departmentList.filter(function(item, pos) {
    return departmentList.indexOf(item) == pos;
  })
  departments.unshift('ALL');

  const positionList  = Array.from(employeeRegistry.values()).map((emp) => {
    return emp["position"];
  });
  const positions = positionList.filter(function(item, pos) {
    return positionList.indexOf(item) == pos;
  })
  positions.unshift('ALL');

  const [open, setOpen] = useState(false);
  return (
    <Container fluid>
      <Table singleLine compact>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Name</Table.HeaderCell>
            <Table.HeaderCell>Email</Table.HeaderCell>
            <Table.HeaderCell>Employee Status</Table.HeaderCell>
            <Table.HeaderCell>
            <Dropdown text='Department'>
        <Dropdown.Menu>
          <Dropdown.Header ><span style={{color: 'grey'}}>Choose from below</span></Dropdown.Header>
          <Dropdown.Divider/>
        {departments.map((department) => 
           <Dropdown.Item
             name='department'
             onClick={(e, { name }) =>
             selectEmployeeTitle(name, department)
            }
           >
             {department}
           </Dropdown.Item>)}
          </Dropdown.Menu>
        </Dropdown>
            </Table.HeaderCell>
            <Table.HeaderCell>
            <Dropdown text='Position'>
        <Dropdown.Menu>
          <Dropdown.Header ><span style={{color: 'grey'}}>Choose from below</span></Dropdown.Header>
          <Dropdown.Divider/>
        {positions.map((position) => 
           <Dropdown.Item
             name='position'
             onClick={(e, { name }) =>
             selectEmployeeTitle(name, position)
            }
           >
             {position}
           </Dropdown.Item>)}
          </Dropdown.Menu>
        </Dropdown>
            </Table.HeaderCell>
            <Table.HeaderCell>Mobile</Table.HeaderCell>
            <Table.HeaderCell width={1}>Action</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {employeesByName.map((employee) => (
            <Table.Row key={employee.email}>
              <Table.Cell>
              <Image avatar src={employee.photoUrl || "/assets/user.png"}/>
                <strong>{employee.name}</strong>&nbsp;&nbsp;
                {(employee.qualified === 'N') ? 
                <Popup content='Certificates are missing, please view details' trigger={
              <Message negative size='mini' compact style={{padding: '0em 0.5em'}}>
                Unqualified</Message>} /> : <Message color='green' size='mini' compact style={{padding: '0em 0.5em'}}>
                Qualified</Message>}
              </Table.Cell>
              <Table.Cell>{employee.email}</Table.Cell>
              <Table.Cell>{employee.status}</Table.Cell>
              <Table.Cell>{employee.department}</Table.Cell>
              <Table.Cell>{employee.position}</Table.Cell>
              <Table.Cell>{employee.mobile}</Table.Cell>
              
              <Table.Cell>
                <Button.Group>
                  <Button
                    as={Link}
                    to={`/hrmanagement/employees/${employee.email}`}
                    size="mini"
                    icon="zoom in"
                    color="blue"
                    title="View"
                  />
                  <Button
                    as={Link}
                    to={`/hrmanagement/employees-edit/${employee.email}`}
                    size="mini"
                    icon="edit"
                    color="yellow"
                    title="Edit"
                  />
                  <Button 
                    name={employee.email}
                    size="mini"
                    loading={target === employee.email && submitting}
                    onClick={() => {
                        setOpen(true);
                        setEmployeeEmail(employee.email);
                    }}
                    icon="delete"
                    color="red"
                    title="Delete"
                  />
                  <Confirm 
                    open={open}
                    onCancel={() => setOpen(false)}
                    onConfirm={() => {
                        deleteEmployee(employeeEmail);
                        setOpen(false);
                    }}
                    content="Are you sure you want to delete?"
                    confirmButton="Yes"
                    size="mini"
                    style={{
                        position:"relative",
                        maxHeight:"150px",
                        height: "auto"
                    }}
                  />
                </Button.Group>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </Container>
  );
};
export default observer(EmployeeList);
